import React, { useEffect, useState } from "react";
import styles from "./ChangeMaterialStatus.module.css";
import t from "../../utils/translation";
import request from "../../utils/request";
import SelectQ from "../../components/FormComponents/SelectQ/SelectQ";
import { FiArrowRightCircle } from "react-icons/fi";
import InputQ from "../FormComponents/InputQ/InputQ";
import { CiImageOn } from "react-icons/ci";
import ImageModal from "../../components/ImageModal/ImageModal";
import { FaPlus, FaMinus } from 'react-icons/fa'; 
import SelectMaterial from '../SelectMaterial/SelectMaterial';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUserCompany } from "../../utils/sessionHandler";
import { HiScissors } from "react-icons/hi2";


const ChangeMaterialStatus = (locale) => {
  const [materials, setMaterials] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [inputMaterial, setInputMaterial] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [originQuantity, setOriginQuantity] = useState(0);
  const [destStatusOptions, setDestStatusOptions] = useState([]);
  const [selectedDestStatus, setSelectedDestStatus] = useState("");
  const [destQuantity, setDestQuantity] = useState(0);
  const [originalOriginQuantity, setOriginalOriginQuantity] = useState(0);
  const [originalDestQuantity, setOriginalDestQuantity] = useState(0);
  const [quantityToMove, setQuantityToMove] = useState(0);
  const [materialState, setMaterialState] = useState([]);
  const [quantityError, setQuantityError] = useState("");
  const [error,setError] = useState("")
  const [validate,setValidate] = useState("")


  const handleSelectedMaterial = (material) => {
    setSelectedMaterial(material);
    setStatusOptions(material?.statusQuantities || []);
    setSelectedStatus("");
    setOriginQuantity(0);
    setQuantityToMove(0);
    setSelectedDestStatus("");
    setDestQuantity(0);
    setOriginalOriginQuantity(0);
    setOriginalDestQuantity(0);
  };

 const handleStatusChange = (e) => {
  const statusId = (e.target.value);

  const statusItem = selectedMaterial.statusQuantities.find(
    (s) => s.statusName === statusId
  );

  if (statusItem) {
    setSelectedStatus(statusItem);

    const quantity = statusItem.quantity;
    setOriginQuantity(quantity);
    setOriginalOriginQuantity(quantity);
    updateQuantities(quantityToMove, quantity, destQuantity);
  } else {
    setSelectedStatus(null);
    setOriginQuantity(0);
    setOriginalOriginQuantity(0);
  }
};

  const handleDestStatusChange = (e) => { 
    const statusId = e.target.value;
    const destStatusItem = materialState.find(
      (s) => s.statusMaterial === statusId
    );
  
    if (destStatusItem) {
      setSelectedDestStatus(destStatusItem);
  
      const materialEntry = destStatusItem.quantityByMaterial.find(
        (m) => m.name === selectedMaterial.materialName
      );
      const quantity = materialEntry ? materialEntry.quantity : 0;
      setDestQuantity(quantity);
      setOriginalDestQuantity(quantity);
      updateQuantities(quantityToMove, originalOriginQuantity, quantity);
    } else {
      setSelectedDestStatus(null);
      setDestQuantity(0);
      setOriginalDestQuantity(0);
    }
  };

  const updateQuantities = (moveQty, originQty, destQty) => {
    setOriginQuantity(Math.max(0, originQty - moveQty));
    setDestQuantity(destQty + moveQty);
  };

  const handleInputChange = (e) => {
  setQuantityError("");
  const value = e.target.value;

  if (value === "") {
    setQuantityToMove("");
    return;
  }

  const regex = /^[0-9\b]+$/;
  if (!regex.test(value)) {
    setQuantityToMove(0);
    updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    setQuantityError("Debe ingresar solo números.");
    return;
  }

  const numericValue = Math.max(0, Number(value));

  if (!selectedStatus) {
    setQuantityToMove(0);
    updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    setQuantityError(t("BlankEntry151") || "You must select a state of origin.");
    return;
  }

  if (!selectedDestStatus) {
    setQuantityToMove(0);
    updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    setQuantityError(t("BlankEntry152") || "You must select a destination state.");
    return;
  }

  if (numericValue > originalOriginQuantity) {
    setQuantityToMove(0);
    updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    setQuantityError(t("BlankEntry153") || "The quantity cannot exceed the quantity in its original state.");
    return;
  }

  setQuantityToMove(numericValue);
  updateQuantities(numericValue, originalOriginQuantity, originalDestQuantity);
};

  const handleBlur = () => {
    if (quantityToMove === "" || isNaN(quantityToMove)) {
      setQuantityToMove(0);
      updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    }
  };

  const handleIncrease = () => {
  const newQty = quantityToMove + 1;

  if (!selectedStatus) {
    setQuantityError(t("BlankEntry151") || "You must select a state of origin.");
    return;
  }

  if (!selectedDestStatus) {
    setQuantityError(t("BlankEntry152") || "You must select a destination state.");
    return;
  }

  if (newQty > originalOriginQuantity) {
    setQuantityToMove(0);
    updateQuantities(0, originalOriginQuantity, originalDestQuantity);
    setQuantityError(t("BlankEntry153") || "The quantity cannot exceed the quantity in its original state.");
    return;
  }

  setQuantityToMove(newQty);
  updateQuantities(newQty, originalOriginQuantity, originalDestQuantity);
  setQuantityError(""); 
};

  const handleDecrease = () => {
    const newQty = quantityToMove > 0 ? quantityToMove - 1 : 0;
    setQuantityToMove(newQty);
    updateQuantities(newQty, originalOriginQuantity, originalDestQuantity);
  };


   const handleAddStock = async () => {
          if (quantityToMove === 0 || quantityToMove === "" || quantityToMove === null) {
            toast.error(t("BlankEntry154") || 'Must add stock');
            return;
          }
          try {
              const bodyRequest = {
                  "materialStockId": selectedMaterial.material?.materialId,
                  "StatusFrom": selectedStatus.statusId,
                  "statusTo": selectedDestStatus.statusMaterialId,
                  "QuantityToMove": quantityToMove
              };
                await request().put("/Api/materialStock/modifyStock", bodyRequest);
                toast.success(t("BlankEntry150") || "Stock added successfully");
                setError("");
                setValidate(false);
                setInputMaterial("");
                setSelectedMaterial(null);
          } catch (error) {
            toast.error(error.response.data.message);
          }
        };

  const handleModalImage = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const getMaterials = async () => {
    try {
      let res = await request().get("/api/materialStock/listByMaterial");
      setMaterials(res.data);
    } catch (error) {
      console.error("Error fetching materials:", error);
    }
  };

  const getMaterialState = async () => {
    try {
      let res = await request().get(`/api/materialStock/listByStatus?CompanyId=${getUserCompany().Id}`);
      const allowedStatusIds = [1, 4, 12, 13, 14, 15];
      const filteredData = res.data.filter(item => allowedStatusIds.includes(item.statusMaterialId));
      setMaterialState(filteredData);
      setDestStatusOptions(filteredData);
    } catch (error) {
      console.error("Error fetching material state:", error);
    }
  };

  useEffect(() => {
    getMaterials();
    getMaterialState();
  }, []);

  return (
<div className={styles.containerLayout}>
    <ToastContainer />
  {/* Columna Izquierda */}
<div className={styles.leftColumn}>
  <div className={styles.leftSearchWrapper}>
    <SelectMaterial
      handleInputChange={setInputMaterial}
      value={inputMaterial}
      placeholder= {t("BlankEntry36") || "Search material"}
      name="material"
      options={materials}
      onOptionSelect={handleSelectedMaterial}
      labelProp="materialName"
      containerWidth="500px"
    />
  </div>

  <div className={styles.leftPackagesScroll}>
    {selectedMaterial ? (
      <div className={styles.materialCard}>
        <div className={styles.cardHeaderContainer}>
          <div className={styles.cardHeader}>
            {selectedMaterial.materialName || "Material"}
          </div>
          <div
            className={styles.imageButton}
            onClick={() => handleModalImage(selectedMaterial)}
          >
            <CiImageOn />
          </div>
        </div>

          <div className={styles.materialDetails}>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("BlankEntry155") || "Total Stock"}:</span>
              <span className={styles.value}>{selectedMaterial.totalMaterialStock}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("TypeOfMaterialSpan") || "Type"}:</span>
              <span className={styles.value}>{selectedMaterial.material?.materialTypeName}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("SerialSpan") || "Serial"}:</span>
              <span className={styles.value}>{selectedMaterial.material?.materialSerial || "N/A"}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("BlankEntry95") || "Cycles"}</span>
              <span className={styles.value}>{selectedMaterial.material?.cyclesWarning}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("BlankEntry93") || "Implant"}:</span>
              <span className={styles.value}>{selectedMaterial.material?.isImplant ? "Yes" : "No"}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("BlankEntry94") || "Endoscope"}:</span>
              <span className={styles.value}>{selectedMaterial.material?.isEndoscope ? "Yes" : "No"}</span>
            </div>
            <div className={styles.detailRow}>
              <span className={styles.label}>{t("BlankEntry98") || "Compatible Method"}:</span>
              <span className={styles.value}>{selectedMaterial.material?.methodName}</span>
            </div>
          </div>
      </div>
    ) : (
      <div className={styles.noMaterialIcon}>
        <HiScissors />
      </div>
    )}
  </div>

  {modalOpen && (
    <ImageModal
      imageSrc={selectedMaterial?.material?.imageLink}
      onClose={handleCloseModal}
    />
  )}
</div>

  {/* Contenido Principal */}
  <div className={styles.mainContent}>
    {selectedMaterial ? (
            <div className={styles.inputContainer}>
                  <div className={styles.inputRow}>
                    <SelectQ
                      containerWidth={"50%"}
                      name={"statusName"}
                      label={t("BlankEntry156") || "Origin State"}
                      placeholder={t("BlankEntry156") || "Origin State"}
                      labelTop={true}
                      options={statusOptions.map((s) => ({
                        name: s.statusName,
                      }))}
                      value={selectedStatus}
                      handleSelect={handleStatusChange}
                      border={true}
                    />

                    <FiArrowRightCircle className={styles.arrowIcon} />

                    <SelectQ
                      placeholder={t("BlankEntry157") || " Destination State"}
                      label={t("BlankEntry157") || "Destination State"}
                      name={"newStateId"}
                      labelTop
                      containerWidth={"50%"}
                      options={destStatusOptions
                        .filter((s) => s.statusMaterial !== selectedStatus?.statusName)
                        .map((s) => ({
                          name: s.statusMaterial,
                        }))}
                      value={selectedDestStatus}
                      handleSelect={handleDestStatusChange}
                      border={true}
                    />
                  </div>

                  <div className={styles.inputRow}>
                    <InputQ
                      label={t("BlankEntry158", locale) || "Quantity in state of origin"}
                      name="originQuantity"
                      labelTop
                      containerWidth={"50%"}
                      leftMessage
                      value={originQuantity}
                      disabled
                    />
                    <FiArrowRightCircle className={styles.arrowIcon} />
                    <InputQ
                      label={t("BlankEntry159", locale) || "Quantity in destination state"}
                      name="destQuantity"
                      labelTop
                      containerWidth={"50%"}
                      leftMessage
                      value={destQuantity}
                      disabled
                    />
                  </div>

                  <div className={styles.inputRow}>
                    <div className={styles.quantitySection}>
                      <label className={styles.label}>
                        {t("BlankEntry160") || "Amount to be transferred to the destination state"}
                      </label>
                      <div className={styles.inputWrapper}>
                        <input
                          type="number"
                          className={styles.input}
                          value={quantityToMove}
                          min="0"
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                        />
                        <div className={styles.buttons}>
                          <button
                            type="button"
                            className={styles.controlButton}
                            onClick={handleDecrease}
                          >
                            <FaMinus />
                          </button>
                          <button
                            type="button"
                            className={styles.controlButton}
                            onClick={handleIncrease}
                          >
                            <FaPlus />
                          </button>
                        </div>
                      </div>

                     {quantityError && (
                      <span className={styles.errorMessage}>
                        {quantityError}
                      </span>
                    )}

                      <button
                        className={`${styles.searchActionButton} ${styles.searchButton}`}
                        onClick={handleAddStock}
                      >
                        {t("BlankEntry161" ||"Transfer amounts")}
                      </button>
                    </div>
                  </div>
                </div>
                 ) : (
                  <div className={styles.noMaterialText}>
                    {t("BlankEntry162" || "Search for a material on the left")}
                  </div>
                 )}
  </div>
</div>
  );
};

export default ChangeMaterialStatus;
